import { css } from "@emotion/css";
import React, { useEffect, useState } from "react";
import { Alert, Col, Table } from "react-bootstrap";
import AnimateWrapper from "../util/AnimateWrapper";
import BasicQuestion from "../util/BasicQuestion";
import { useBreadcrumbs } from "../util/BreadcrumbContext";
import ChoiceCard from "../util/ChoiceCard";
import ContentsTemplate from "../util/ContentsTemplate";
import TariffTable from "../util/TariffTable";
import { useSnackbar } from "react-simple-snackbar";
import { danger } from "../util/AlertStyles";

const Contents = () => {
    const [amount, setAmount] = useState(window.sessionStorage.getItem("contents") ? JSON.parse(window.sessionStorage.getItem("contents")).length : 1);
    const [contents, setContents] = useState(window.sessionStorage.getItem("contents") ? JSON.parse(window.sessionStorage.getItem("contents")) : [{}]);
    const { addBreadcrumb } = useBreadcrumbs();

    const [addAlert] = useSnackbar(danger);

    const updateContents = (index) => (contentLine) => {
        let current = [...contents];
        while (index > current.length) {
            current.push({});
        }
        current[index] = contentLine;
        setContents(current);
    };

    const nextPage = () => {
        if (Object.entries(contents[0]).filter(([k, v]) => v || v === 0).length !== 9) {
            addAlert("Vul alstublieft alle velden in.")
            return;
        }
        addBreadcrumb(
            {
                href: "/instructions",
                text: "Instructies"
            },
            { contents }
        );
    };

    useEffect(() => {
        if (contents && contents[0]) window.sessionStorage.setItem("contents", JSON.stringify(contents));
    }, [contents]);

    return (
        <AnimateWrapper>
            <BasicQuestion
                fluid="lg"
                question={"Inhoud van het pakket"}
                answers={
                    <>
                        <Col xs={12}>
                            <Alert variant="info">
                                U kunt het Tariff nummer vinden op{" "}
                                <a
                                    href="https://tarief.douane.nl/arctictariff-public-web/#!/taric/nomenclature/sbn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        window.open(
                                            "https://tarief.douane.nl/arctictariff-public-web/#!/taric/nomenclature/sbn",
                                            "_blank"
                                        );
                                    }}
                                >
                                    deze website van de douane.
                                </a>{" "}
                                Zoek daarna tussen
                                de categorieën totdat u een achtcijferig nummer
                                heeft. Vul deze vervolgens in onder Tariff No.
                                Veel voorkomende Tariff nummers zijn te vinden in de volgende tabel:
                                <TariffTable />
                                Controleer <strong>altijd</strong> het tariff nummer via de bovenstaande link.
                            </Alert>
                        </Col>
                        <Col
                            xs={12}
                            className={css`
                                overflow: auto;
                            `}
                        >
                            <Table variant="dark" size="sm" bordered responsive>
                                <thead>
                                    <tr>
                                        <th>Omschrijving</th>
                                        <th>Liters</th>
                                        <th>Jaar</th>
                                        <th>Percentage</th>
                                        <th>Tariff No.</th>
                                        <th>Land van productie</th>
                                        <th>Aantal</th>
                                        <th>Waarde (per stuk, excl. BTW)</th>
                                        <th>Waarde (totaal, excl. BTW)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.apply(0, { length: amount }).map(
                                        (_, index) => (
                                            <ContentsTemplate
                                                key={index}
                                                content={contents[index]}
                                                updateContents={updateContents(
                                                    index
                                                )}
                                            />
                                        )
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                        <Col xs={6}>
                            <ChoiceCard
                                body={"Voeg nog een artikel toe"}
                                onClick={() => {
                                    setAmount(amount + 1);
                                }}
                            />
                        </Col>
                        <Col xs={6}>
                            <ChoiceCard
                                body={"Ga door"}
                                onClick={nextPage}
                            />
                        </Col>
                    </>
                }
            />
        </AnimateWrapper >
    );
};

export default Contents;
